import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('progress-element')
export class ProgressElement extends LitElement {
    private readonly amplitude_callsite: string = 'Progress Element';

    @property({ type: Number })
    currentIndex: number = 1;

    @property({ type: Number })
    totalIndex: number = 1;

    @property({ type: String })
    barColor: string = 'var(--main-success-color)';

    protected render() {
        const total = Math.max(this.totalIndex, 1);
        const current = Math.max(0, Math.min(this.currentIndex + 1, total));
        const progressBarWidth = Math.min((current / total) * 100, 100);
        const progressPercent = Math.round(progressBarWidth);
        return html`
            <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="${current}"
                aria-valuemin="0"
                aria-valuemax="${total}"
                aria-label="${progressPercent}% complete"
                style="width: ${progressBarWidth}%; background-color:${this.barColor}"
            ></div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            :host {
                width: 100%;
                border: 1px solid var(--main-moon-color);
                border-radius: 4px;
                background-color: var(--theme-border-color);
            }

            .progress-bar {
                display: flex;
                gap: 5px;
                align-items: center;
                justify-content: center;
            }

            .progress-bar {
                height: 10px;
            }

            .progress-dot {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: var(--theme-border-color);
                transition: background-color 0.4s ease-in-out;
            }

            .progress-dot.filled {
                background-color: var(--main-success-color);
            }

            .progress-dot.current {
                background-color: #808080;
            }

        `;
    }
}
